// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/cards_acceptance/payment_links/methods/firstparty/v1/common.proto

/* eslint-disable */
import { ApiCurrencyAmount } from "../../../../../common/payment";

/** The status of the method. */
export const ApiMethodStatusValue = {
  /** METHOD_STATUS_VALUE_UNSPECIFIED - Unspecified method status. */
  METHOD_STATUS_VALUE_UNSPECIFIED: "METHOD_STATUS_VALUE_UNSPECIFIED",
  /** METHOD_STATUS_VALUE_INACTIVE - Method is inactive. */
  METHOD_STATUS_VALUE_INACTIVE: "METHOD_STATUS_VALUE_INACTIVE",
  /** METHOD_STATUS_VALUE_ACTIVE - Method is active. */
  METHOD_STATUS_VALUE_ACTIVE: "METHOD_STATUS_VALUE_ACTIVE",
  /** METHOD_STATUS_VALUE_PENDING_REVIEW - Method is pending review. */
  METHOD_STATUS_VALUE_PENDING_REVIEW: "METHOD_STATUS_VALUE_PENDING_REVIEW",
  /** METHOD_STATUS_VALUE_PENDING_EXTERNAL - Method is pending external processing. */
  METHOD_STATUS_VALUE_PENDING_EXTERNAL: "METHOD_STATUS_VALUE_PENDING_EXTERNAL",
  /** METHOD_STATUS_VALUE_PENDING_ONBOARDING - Method is pending onboarding. */
  METHOD_STATUS_VALUE_PENDING_ONBOARDING: "METHOD_STATUS_VALUE_PENDING_ONBOARDING",
  /** METHOD_STATUS_VALUE_REJECTED - Method was rejected. */
  METHOD_STATUS_VALUE_REJECTED: "METHOD_STATUS_VALUE_REJECTED",
} as const;

export type ApiMethodStatusValue = typeof ApiMethodStatusValue[keyof typeof ApiMethodStatusValue];

export namespace ApiMethodStatusValue {
  export type METHOD_STATUS_VALUE_UNSPECIFIED = typeof ApiMethodStatusValue.METHOD_STATUS_VALUE_UNSPECIFIED;
  export type METHOD_STATUS_VALUE_INACTIVE = typeof ApiMethodStatusValue.METHOD_STATUS_VALUE_INACTIVE;
  export type METHOD_STATUS_VALUE_ACTIVE = typeof ApiMethodStatusValue.METHOD_STATUS_VALUE_ACTIVE;
  export type METHOD_STATUS_VALUE_PENDING_REVIEW = typeof ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_REVIEW;
  export type METHOD_STATUS_VALUE_PENDING_EXTERNAL = typeof ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_EXTERNAL;
  export type METHOD_STATUS_VALUE_PENDING_ONBOARDING =
    typeof ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_ONBOARDING;
  export type METHOD_STATUS_VALUE_REJECTED = typeof ApiMethodStatusValue.METHOD_STATUS_VALUE_REJECTED;
}

export function apiMethodStatusValueFromJSON(object: any): ApiMethodStatusValue {
  switch (object) {
    case 0:
    case "METHOD_STATUS_VALUE_UNSPECIFIED":
      return ApiMethodStatusValue.METHOD_STATUS_VALUE_UNSPECIFIED;
    case 1:
    case "METHOD_STATUS_VALUE_INACTIVE":
      return ApiMethodStatusValue.METHOD_STATUS_VALUE_INACTIVE;
    case 2:
    case "METHOD_STATUS_VALUE_ACTIVE":
      return ApiMethodStatusValue.METHOD_STATUS_VALUE_ACTIVE;
    case 3:
    case "METHOD_STATUS_VALUE_PENDING_REVIEW":
      return ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_REVIEW;
    case 4:
    case "METHOD_STATUS_VALUE_PENDING_EXTERNAL":
      return ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_EXTERNAL;
    case 5:
    case "METHOD_STATUS_VALUE_PENDING_ONBOARDING":
      return ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_ONBOARDING;
    case 6:
    case "METHOD_STATUS_VALUE_REJECTED":
      return ApiMethodStatusValue.METHOD_STATUS_VALUE_REJECTED;
    default:
      return ApiMethodStatusValue.METHOD_STATUS_VALUE_UNSPECIFIED;
  }
}

export function apiMethodStatusValueToJSON(object: ApiMethodStatusValue): string {
  switch (object) {
    case ApiMethodStatusValue.METHOD_STATUS_VALUE_UNSPECIFIED:
      return "METHOD_STATUS_VALUE_UNSPECIFIED";
    case ApiMethodStatusValue.METHOD_STATUS_VALUE_INACTIVE:
      return "METHOD_STATUS_VALUE_INACTIVE";
    case ApiMethodStatusValue.METHOD_STATUS_VALUE_ACTIVE:
      return "METHOD_STATUS_VALUE_ACTIVE";
    case ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_REVIEW:
      return "METHOD_STATUS_VALUE_PENDING_REVIEW";
    case ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_EXTERNAL:
      return "METHOD_STATUS_VALUE_PENDING_EXTERNAL";
    case ApiMethodStatusValue.METHOD_STATUS_VALUE_PENDING_ONBOARDING:
      return "METHOD_STATUS_VALUE_PENDING_ONBOARDING";
    case ApiMethodStatusValue.METHOD_STATUS_VALUE_REJECTED:
      return "METHOD_STATUS_VALUE_REJECTED";
    default:
      return "METHOD_STATUS_VALUE_UNSPECIFIED";
  }
}

/** Country code location where a payment method is available. */
export const ApiMethodLocation = {
  /** METHOD_LOCATION_UNSPECIFIED - Unspecified location. */
  METHOD_LOCATION_UNSPECIFIED: "METHOD_LOCATION_UNSPECIFIED",
  /** METHOD_LOCATION_GLOBAL - Available globally. */
  METHOD_LOCATION_GLOBAL: "METHOD_LOCATION_GLOBAL",
  /** METHOD_LOCATION_FR - Available in France. */
  METHOD_LOCATION_FR: "METHOD_LOCATION_FR",
  /** METHOD_LOCATION_NL - Available in Netherlands. */
  METHOD_LOCATION_NL: "METHOD_LOCATION_NL",
  /** METHOD_LOCATION_DE - Available in Germany. */
  METHOD_LOCATION_DE: "METHOD_LOCATION_DE",
  /** METHOD_LOCATION_IT - Available in Italy. */
  METHOD_LOCATION_IT: "METHOD_LOCATION_IT",
} as const;

export type ApiMethodLocation = typeof ApiMethodLocation[keyof typeof ApiMethodLocation];

export namespace ApiMethodLocation {
  export type METHOD_LOCATION_UNSPECIFIED = typeof ApiMethodLocation.METHOD_LOCATION_UNSPECIFIED;
  export type METHOD_LOCATION_GLOBAL = typeof ApiMethodLocation.METHOD_LOCATION_GLOBAL;
  export type METHOD_LOCATION_FR = typeof ApiMethodLocation.METHOD_LOCATION_FR;
  export type METHOD_LOCATION_NL = typeof ApiMethodLocation.METHOD_LOCATION_NL;
  export type METHOD_LOCATION_DE = typeof ApiMethodLocation.METHOD_LOCATION_DE;
  export type METHOD_LOCATION_IT = typeof ApiMethodLocation.METHOD_LOCATION_IT;
}

export function apiMethodLocationFromJSON(object: any): ApiMethodLocation {
  switch (object) {
    case 0:
    case "METHOD_LOCATION_UNSPECIFIED":
      return ApiMethodLocation.METHOD_LOCATION_UNSPECIFIED;
    case 1:
    case "METHOD_LOCATION_GLOBAL":
      return ApiMethodLocation.METHOD_LOCATION_GLOBAL;
    case 2:
    case "METHOD_LOCATION_FR":
      return ApiMethodLocation.METHOD_LOCATION_FR;
    case 3:
    case "METHOD_LOCATION_NL":
      return ApiMethodLocation.METHOD_LOCATION_NL;
    case 4:
    case "METHOD_LOCATION_DE":
      return ApiMethodLocation.METHOD_LOCATION_DE;
    case 5:
    case "METHOD_LOCATION_IT":
      return ApiMethodLocation.METHOD_LOCATION_IT;
    default:
      return ApiMethodLocation.METHOD_LOCATION_UNSPECIFIED;
  }
}

export function apiMethodLocationToJSON(object: ApiMethodLocation): string {
  switch (object) {
    case ApiMethodLocation.METHOD_LOCATION_UNSPECIFIED:
      return "METHOD_LOCATION_UNSPECIFIED";
    case ApiMethodLocation.METHOD_LOCATION_GLOBAL:
      return "METHOD_LOCATION_GLOBAL";
    case ApiMethodLocation.METHOD_LOCATION_FR:
      return "METHOD_LOCATION_FR";
    case ApiMethodLocation.METHOD_LOCATION_NL:
      return "METHOD_LOCATION_NL";
    case ApiMethodLocation.METHOD_LOCATION_DE:
      return "METHOD_LOCATION_DE";
    case ApiMethodLocation.METHOD_LOCATION_IT:
      return "METHOD_LOCATION_IT";
    default:
      return "METHOD_LOCATION_UNSPECIFIED";
  }
}

/** Status information for a payment method. */
export interface ApiMethodStatus {
  /** The current status value of the method. */
  readonly value: ApiMethodStatusValue;
  /** Action information related to the method status. */
  readonly action?: ApiMethodStatusMethodStatusAction | null | undefined;
}

/** Action information related to the method status. */
export interface ApiMethodStatusMethodStatusAction {
  /** URL for the action to be taken. Redirect user to the specified url */
  readonly url: string;
}

/** Fee structure for a payment method. */
export interface ApiMethodFee {
  /** The id of the fee. */
  readonly id: string;
  /** Optional fixed amount fee in the specified currency. */
  readonly fixedAmount?:
    | ApiCurrencyAmount
    | null
    | undefined;
  /** Optional percentage-based fee. */
  readonly percentageAmount?: string | null | undefined;
}

/** Represents a payment method available for payment links. */
export interface ApiMethod {
  /** Unique identifier for the method. Supported method id : apple_pay, credit_card, paypal, bank_transfer, ideal */
  readonly id: string;
  /** Current status of the method. */
  readonly status:
    | ApiMethodStatus
    | null;
  /** Country code locations where this method is available. */
  readonly locations: readonly ApiMethodLocation[];
  /** Settlement time information for the method. */
  readonly settlementTimeInDays?:
    | number
    | null
    | undefined;
  /** Fee structure for this method. */
  readonly fees: readonly ApiMethodFee[];
}

export const ApiMethodStatus: MessageFns<ApiMethodStatus> = {
  fromJSON(object: any): ApiMethodStatus {
    return {
      value: isSet(object.value)
        ? apiMethodStatusValueFromJSON(object.value)
        : ApiMethodStatusValue.METHOD_STATUS_VALUE_UNSPECIFIED,
      action: isSet(object.action) ? ApiMethodStatusMethodStatusAction.fromJSON(object.action) : null,
    };
  },

  toJSON(message: ApiMethodStatus): unknown {
    const obj: any = {};
    if (message.value !== ApiMethodStatusValue.METHOD_STATUS_VALUE_UNSPECIFIED) {
      obj.value = apiMethodStatusValueToJSON(message.value);
    }
    if (message.action !== undefined && message.action !== null) {
      obj.action = ApiMethodStatusMethodStatusAction.toJSON(message.action);
    }
    return obj;
  },
};

export const ApiMethodStatusMethodStatusAction: MessageFns<ApiMethodStatusMethodStatusAction> = {
  fromJSON(object: any): ApiMethodStatusMethodStatusAction {
    return { url: isSet(object.url) ? globalThis.String(object.url) : "" };
  },

  toJSON(message: ApiMethodStatusMethodStatusAction): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },
};

export const ApiMethodFee: MessageFns<ApiMethodFee> = {
  fromJSON(object: any): ApiMethodFee {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      fixedAmount: isSet(object.fixedAmount) ? ApiCurrencyAmount.fromJSON(object.fixedAmount) : null,
      percentageAmount: isSet(object.percentageAmount) ? globalThis.String(object.percentageAmount) : null,
    };
  },

  toJSON(message: ApiMethodFee): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.fixedAmount !== undefined && message.fixedAmount !== null) {
      obj.fixedAmount = ApiCurrencyAmount.toJSON(message.fixedAmount);
    }
    if (message.percentageAmount !== undefined && message.percentageAmount !== null) {
      obj.percentageAmount = message.percentageAmount;
    }
    return obj;
  },
};

export const ApiMethod: MessageFns<ApiMethod> = {
  fromJSON(object: any): ApiMethod {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      status: isSet(object.status) ? ApiMethodStatus.fromJSON(object.status) : null,
      locations: globalThis.Array.isArray(object?.locations)
        ? object.locations.map((e: any) => apiMethodLocationFromJSON(e))
        : [],
      settlementTimeInDays: isSet(object.settlementTimeInDays) ? globalThis.Number(object.settlementTimeInDays) : null,
      fees: globalThis.Array.isArray(object?.fees) ? object.fees.map((e: any) => ApiMethodFee.fromJSON(e)) : [],
    };
  },

  toJSON(message: ApiMethod): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.status !== undefined && message.status !== null) {
      obj.status = ApiMethodStatus.toJSON(message.status);
    }
    if (message.locations?.length) {
      obj.locations = message.locations.map((e) => apiMethodLocationToJSON(e));
    }
    if (message.settlementTimeInDays !== undefined && message.settlementTimeInDays !== null) {
      obj.settlementTimeInDays = Math.round(message.settlementTimeInDays);
    }
    if (message.fees?.length) {
      obj.fees = message.fees.map((e) => ApiMethodFee.toJSON(e));
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
